import styled from "styled-components";

interface IDesktop {
  isDesktop?: boolean
  bgColor?: string;
  isFixed?: boolean;
}

export const NavigationBarWithIcon = styled.div<IDesktop>`
  background: ${(props) => props.bgColor ? props.bgColor : "white"};
  position:  ${(props) => props.isFixed ? "fixed": "relative"};;
  width: 100%;
  height: ${(props) => props.isDesktop ? "140px" : "58px"};
  border: none;
  z-index: 2;
  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding-left: ${(props) => props.isDesktop ? "40px" : "5px"};
  padding-right: ${(props) => props.isDesktop ? "40px" : "5px"};;

  div {
    width: 100%;
    display: flex;
    justify-content: center;
  }
`

interface IICons extends IDesktop {
  desktopSize: {
    width: string;
    height: string;
  };
  mobileSize: {
    width: string;
    height: string;
  }
}

export const Icon = styled.img<IICons>`
  margin-right: 5px;
  width: ${(props) => props.isDesktop ? props.desktopSize.width : props.mobileSize.width };
  height: ${(props) => props.isDesktop ? props.desktopSize.height : props.mobileSize.height };
`
